import { render, staticRenderFns } from "./PFSettlementAdjReason.vue?vue&type=template&id=5d8bd5b8"
import script from "./PFSettlementAdjReason.vue?vue&type=script&lang=js"
export * from "./PFSettlementAdjReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports